"use client"

import { useCheckHover } from "@/hooks"
import { cn } from "@/lib/cn"
import { SVGIcon } from "@/types/icon"
import React from "react"
import { logoIpsumIconStyle } from "./logoipsum-icon-style"

const LogoIpsum1: React.FC<SVGIcon> = ({ className, ...props }) => {
  const { isHover, handleHoverState } = useCheckHover()

  return (
    <svg
      {...props}
      onMouseOver={() => handleHoverState(true)}
      onMouseOut={() => handleHoverState(false)}
      className={cn("cursor-pointer", className)}
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 142}
      height={props?.height ?? 34}
      viewBox="0 0 142 34"
      fill="none">
      <g clipPath="url(#clip0_1_375)">
        <path
          d="M43.3155 24.3168H53.2269V21.3314H46.8382V10.0865H43.3155V24.3168Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M59.099 22.3266C57.6859 22.3266 56.9496 21.0926 56.9496 19.2417C56.9496 17.3907 57.6859 16.1369 59.099 16.1369C60.5121 16.1369 61.2684 17.3907 61.2684 19.2417C61.2684 21.0926 60.5121 22.3266 59.099 22.3266ZM59.1189 24.6352C62.4028 24.6352 64.5523 22.3067 64.5523 19.2417C64.5523 16.1767 62.4028 13.8481 59.1189 13.8481C55.8549 13.8481 53.6656 16.1767 53.6656 19.2417C53.6656 22.3067 55.8549 24.6352 59.1189 24.6352Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M70.2364 27.8395C71.749 27.8395 73.0825 27.5012 73.9781 26.7051C74.7941 25.9687 75.3314 24.8542 75.3314 23.3217V14.1268H72.2267V15.2214H72.1868C71.5898 14.3656 70.6743 13.8282 69.3209 13.8282C66.7933 13.8282 65.0419 15.9379 65.0419 18.9232C65.0419 22.0479 67.1714 23.7595 69.4602 23.7595C70.6942 23.7595 71.4704 23.262 72.0674 22.5853H72.147V23.6003C72.147 24.8343 71.5699 25.5508 70.1966 25.5508C69.1219 25.5508 68.5845 25.093 68.4054 24.5556H65.2608C65.5792 26.6852 67.4302 27.8395 70.2364 27.8395ZM70.2165 21.3513C69.0025 21.3513 68.2064 20.3562 68.2064 18.8237C68.2064 17.2713 69.0025 16.2762 70.2165 16.2762C71.5699 16.2762 72.2864 17.4306 72.2864 18.8038C72.2864 20.2368 71.6296 21.3513 70.2165 21.3513Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M81.7155 22.3266C80.3024 22.3266 79.566 21.0926 79.566 19.2417C79.566 17.3907 80.3024 16.1369 81.7155 16.1369C83.1285 16.1369 83.8845 17.3907 83.8845 19.2417C83.8845 21.0926 83.1285 22.3266 81.7155 22.3266ZM81.7354 24.6352C85.0189 24.6352 87.1684 22.3067 87.1684 19.2417C87.1684 16.1767 85.0189 13.8481 81.7354 13.8481C78.4714 13.8481 76.2821 16.1767 76.2821 19.2417C76.2821 22.3067 78.4714 24.6352 81.7354 24.6352Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M88.1163 24.3168H91.3604V14.1267H88.1163V24.3168ZM88.1163 12.7137H91.3604V10.0865H88.1163V12.7137Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M92.7676 27.6803H96.0117V23.262H96.0515C96.6884 24.1178 97.6238 24.6352 98.9374 24.6352C101.604 24.6352 103.376 22.5256 103.376 19.2218C103.376 16.1568 101.724 13.8282 99.017 13.8282C97.6238 13.8282 96.6287 14.4452 95.9321 15.3607H95.8724V14.1268H92.7676V27.6803ZM98.1015 22.1275C96.7083 22.1275 95.9122 20.9931 95.9122 19.3412C95.9122 17.6893 96.6287 16.4354 98.0418 16.4354C99.435 16.4354 100.092 17.5898 100.092 19.3412C100.092 21.0727 99.3354 22.1275 98.1015 22.1275Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M108.657 24.6352C111.324 24.6352 113.295 23.4809 113.295 21.2518C113.295 18.6446 111.185 18.1869 109.394 17.8883C108.1 17.6495 106.946 17.55 106.946 16.8335C106.946 16.1966 107.563 15.8981 108.359 15.8981C109.254 15.8981 109.871 16.1767 109.991 17.0922H112.976C112.817 15.0821 111.264 13.8282 108.379 13.8282C105.97 13.8282 103.98 14.9428 103.98 17.0922C103.98 19.4805 105.871 19.9582 107.642 20.2567C108.996 20.4955 110.23 20.595 110.23 21.5106C110.23 22.1673 109.613 22.5256 108.637 22.5256C107.563 22.5256 106.886 22.028 106.767 21.013H103.702C103.801 23.262 105.672 24.6352 108.657 24.6352Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M117.701 24.6153C119.114 24.6153 120.01 24.0581 120.746 23.0629H120.806V24.3168H123.911V14.1267H120.667V19.8188C120.667 21.0329 119.99 21.8688 118.876 21.8688C117.841 21.8688 117.343 21.2518 117.343 20.1373V14.1267H114.119V20.814C114.119 23.0828 115.353 24.6153 117.701 24.6153Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          d="M125.322 24.3168H128.566V18.6048C128.566 17.3908 129.163 16.5349 130.178 16.5349C131.154 16.5349 131.611 17.1718 131.611 18.2665V24.3168H134.856V18.6048C134.856 17.3908 135.433 16.5349 136.468 16.5349C137.443 16.5349 137.901 17.1718 137.901 18.2665V24.3168H141.145V17.6893C141.145 15.4005 139.99 13.8282 137.682 13.8282C136.368 13.8282 135.273 14.3855 134.477 15.6194H134.438C133.92 14.5248 132.905 13.8282 131.572 13.8282C130.099 13.8282 129.124 14.5248 128.487 15.5796H128.427V14.1268H125.322V24.3168Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4621 33.4388C26.622 33.4388 34.0475 26.0132 34.0475 16.8534C34.0475 7.69358 26.622 0.268066 17.4621 0.268066C8.30228 0.268066 0.87677 7.69358 0.87677 16.8534C0.87677 26.0132 8.30228 33.4388 17.4621 33.4388ZM20.0221 13.0824C21.4358 11.6686 21.4358 9.37638 20.0221 7.96256C18.6082 6.54876 16.3161 6.54876 14.9022 7.96256C13.4885 9.37638 13.4885 11.6686 14.9022 13.0824L17.4621 15.6423L20.0221 13.0824ZM21.2332 19.4133C22.647 20.8272 24.9392 20.8272 26.353 19.4133C27.7668 17.9995 27.7668 15.7073 26.353 14.2935C24.9392 12.8798 22.647 12.8798 21.2332 14.2935L18.6733 16.8535L21.2332 19.4133ZM20.0221 25.7443C21.4358 24.3305 21.4358 22.0383 20.0221 20.6245L17.4621 18.0646L14.9022 20.6245C13.4885 22.0383 13.4885 24.3305 14.9022 25.7443C16.3161 27.1581 18.6082 27.1581 20.0221 25.7443ZM8.57124 19.4133C7.15747 17.9995 7.15747 15.7073 8.57124 14.2935C9.98509 12.8798 12.2773 12.8798 13.6911 14.2935L16.251 16.8535L13.6911 19.4133C12.2773 20.8272 9.98509 20.8272 8.57124 19.4133Z"
          fill={props.fill ?? logoIpsumIconStyle(isHover)}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_375">
          <rect
            width="140.976"
            height={34}
            fill="white"
            transform="translate(0.792664)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export { LogoIpsum1 }
